module.exports = __webpack_public_path__ + "img/三体.94ac1cfe.webp";